const initialState = {
    get: [],
    country:[],
    states:[],
    
  };
  
  const ARegionRegions = (state = initialState, action: any) => {
    switch (action.type) {
      case 'fetch_GET_success':
        return { ...state, get: action.payload };
            case 'fetch_Country_success':
                return { ...state, country: action.payload };
                case 'fetch_State_success':
                return { ...state, states: action.payload };
        
      
    

      default:
        return state;
    }
  };
  
  export default ARegionRegions;
  
  